import React from 'react';

import {
  ContentContainer,
  FooterLinks,
  FooterText,
  LoggedOutContainer,
  LogoContainer,
  LogoSubtitle,
  LogoTextContainer,
  LogoTitleBold,
  Title,
} from './styles';
import Logo from '../../assets/Logo';
import ActionButton from '../../presentation/components/ActionButton/ActionButton';
import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { dataProtectionPath, imprintPath, termsPath } from '../../routes';

const LoggedOutPage: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
  const { t } = useI18n();

  return (
    <LoggedOutContainer>
      <ContentContainer>
        <LogoContainer>
          <Logo />
          <LogoTextContainer>
            <LogoTitleBold>
              {t(TranslationKeys.loggedOutPage_cropConnect)}
            </LogoTitleBold>
            <LogoSubtitle>
              {t(TranslationKeys.loggedOutPage_byNordzucker)}
            </LogoSubtitle>
          </LogoTextContainer>
        </LogoContainer>
        <Title>{t(TranslationKeys.loggedOutPage_title)}</Title>
        <ActionButton
          variant="accept-blue"
          onClickAction={onLogin}
          buttonText={t(TranslationKeys.loggedOutPage_button_login)}
        />
        <FooterLinks>
          <a href={imprintPath}>
            {t(TranslationKeys.loggedOutPage_footer_imprint)}
          </a>{' '}
          ·
          <a href={dataProtectionPath}>
            {t(TranslationKeys.loggedOutPage_footer_dataProtection)}
          </a>{' '}
          ·
          <a href={termsPath}>
            {t(TranslationKeys.loggedOutPage_footer_terms)}
          </a>
        </FooterLinks>
        <FooterText>
          {t(TranslationKeys.loggedOutPage_footer_copyright)}
        </FooterText>
      </ContentContainer>
    </LoggedOutContainer>
  );
};

export default LoggedOutPage;
